import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginBenefits = () => {
  const benefits = [
    {
      icon: 'Heart',
      title: 'Save Your Favourites',
      description: 'Keep track of practitioners and events you love with our save feature'
    },
    {
      icon: 'Calendar',
      title: 'Easy Booking',
      description: 'Book sessions and events directly through our integrated booking system'
    },
    {
      icon: 'MapPin',
      title: 'Local Recommendations',
      description: 'Get personalised suggestions based on your location and preferences'
    },
    {
      icon: 'Bell',
      title: 'Stay Updated',
      description: 'Receive notifications about new events and updates from your favourite practitioners'
    }
  ];

  return (
    <div className="hidden lg:block lg:w-1/2 bg-primary/5 p-12">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Sparkles" size={40} color="white" />
          </div>
          <h2 className="text-3xl font-semibold text-foreground mb-4">
            Connect. Practice. Evolve.
          </h2>
          <p className="text-muted-foreground text-lg">
            Join our community of wellness seekers and holistic practitioners across the UK
          </p>
        </div>

        <div className="space-y-8">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={benefit?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-2">
                  {benefit?.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-card rounded-lg shadow-organic">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name="Shield" size={20} color="var(--color-success)" />
            </div>
            <div>
              <h4 className="font-semibold text-foreground">Secure & Private</h4>
              <p className="text-xs text-muted-foreground">Your data is protected</p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            We use industry-standard encryption to keep your personal information safe and secure.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginBenefits;